.rootDark {
    composes: dark from "../../styles/theming.module.css";
}

.rootLight {
    composes: light from "../../styles/theming.module.css";
}
